// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Tooltip } from 'primereact/tooltip';
import { Toast } from 'primereact/toast';

// Multi lang
import { getLanguage, withTranslation } from 'react-multi-lang';

// Styling
import './other-data.scss';

// Redux
import { connect } from 'react-redux';
import ProfileService from '../../../redux/services/profile';
import { getAssociateData, setEditMode } from '../../../redux/actions/profile';

// Utils
import { OTHER_ROLES, YES_OPTION } from '../../../common/constants';
import { formatAssociateDataToService } from '../../../common/formatters/associate';
import { formatYesNoDropdownLists, getYesNoDropdownList } from '../../../common/utils/form-data-utils';

class OtherDataComponent extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            businessOwner: null,
            businessName: "",
            professionalsNumber: "",
            hasManagementRole: null,
            managementRoles: [],
            hasPublicAdminRole: null,
            publicAdminRoles: [],
            hasEthicsCommitteeRole: null,
            ethicsCommitteeRoles: [],
            hasQualityCommitteRole: null,
            qualityCommitteRoles: [],
            hasOrganizationalRole: null,
            organizationalRoles: [],
            readOnlyMode: true,
            addEthicsMode: false,
            addManagementMode: false,
            addPublicAdminMode: false,
            addQualityMode: false,
            addOrganizationalMode: false,
            // Cursor variables
            cursorManagementRole: "",
            cursorManagementWorkplace: "",
            cursorManagementProfessionalsNumber: "",
            cursorManagementBeginDate: null,
            cursorManagementEndDate: null,
            cursorPublicAdminRole: "",
            cursorPublicAdminWorkplace: "",
            cursorPublicAdminBeginDate: null,
            cursorPublicAdminEndDate: null,
            cursorEthicRole: "",
            cursorEthicWorkplace: "",
            cursorEthicBeginDate: null,
            cursorEthicEndDate: null,
            cursorQualityRole: "",
            cursorQualityWorkplace: "",
            cursorQualityBeginDate: null,
            cursorQualityEndDate: null,
            cursorOrganizationalWorkplace: "",
            cursorOrganizationalBeginDate: null,
            cursorOrganizationalEndDate: null,
            // Mandatory fields validation
            validBusinessName: true,
            validProfessionalsNumber: true,
            validManagementRole: true,
            validManagementProfessionalsNumber: true,
            validManagementWorkplace: true,
            validManagementBeginDate: true,
            validPublicAdminRole: true,
            validPublicAdminWorkplace: true,
            validPublicAdminBeginDate: true,
            validEthicRole: true,
            validEthicBeginDate: true,
            validEthicWorkplace: true,
            validQualityBeginDate: true,
            validQualityRole: true,
            validQualityWorkplace: true,
            validOrganizationalBeginDate: true,
            validOrganizationalWorkplace: true,
            // Management roles validation 
            validManagementRolesRole: [true, true, true],
            validManagementRolesWorkplace: [true, true, true],
            validManagementRolesBeginDate: [true, true, true],
            validManagementRolesProfessionalsNumber: [true, true, true],
            // Public admin roles validation 
            validPublicAdminRolesRole: [true, true, true],
            validPublicAdminRolesWorkplace: [true, true, true],
            validPublicAdminRolesBeginDate: [true, true, true],
            // Ethic roles validation 
            validEthicRolesRole: [true, true, true],
            validEthicRolesWorkplace: [true, true, true],
            validEthicRolesBeginDate: [true, true, true],
            // Quality roles validation 
            validQualityRolesRole: [true, true, true],
            validQualityRolesWorkplace: [true, true, true],
            validQualityRolesBeginDate: [true, true, true],
            // Organizational roles validation 
            validOrganizationalRolesWorkplace: [true, true, true, true, true, true, true, true, true, true],
            validOrganizationalRolesBeginDate: [true, true, true, true, true, true, true, true, true, true]
        };
    }

    componentDidMount() {
        this.setState({
            businessOwner: this.props.associate.otherData.businessOwner,
            businessName: this.props.associate.otherData.businessName,
            professionalsNumber: this.props.associate.otherData.professionalsNumber,
            hasManagementRole: this.props.associate.otherData.hasManagementRole,
            managementRoles: this.props.associate.otherData.managementRoles,
            hasPublicAdminRole: this.props.associate.otherData.hasPublicAdminRole,
            publicAdminRoles: this.props.associate.otherData.publicAdminRoles,
            hasEthicsCommitteeRole: this.props.associate.otherData.hasEthicsCommitteeRole,
            ethicsCommitteeRoles: this.props.associate.otherData.ethicsCommitteeRoles,
            hasQualityCommitteRole: this.props.associate.otherData.hasQualityCommitteRole,
            qualityCommitteRoles: this.props.associate.otherData.qualityCommitteRoles,
            hasOrganizationalRole: this.props.associate.otherData.hasOrganizationalRole,
            organizationalRoles: this.props.associate.otherData.organizationalRoles
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.language !== prevProps.language) {
            this.reloadFormData();
        }
    }

    activateEditMode() {
        this.setState({
            readOnlyMode: false,
            addEthicsMode: false,
            addManagementMode: false,
            addOrganizationalMode: false,
            addPublicAdminMode: false,
            addQualityMode: false
        });

        this.props.setEditMode(true);
    }

    cancelEditMode() {
        this.clearComponentVariables();
        this.reloadFormData();
        this.props.setEditMode(false);
    }

    reloadFormData() {
        let associate = this.formatOtherDataFormValues(this.props.associate, this.props.language);

        this.setState({
            businessOwner: associate.otherData.businessOwner,
            businessName: this.props.associate.otherData.businessName,
            professionalsNumber: this.props.associate.otherData.professionalsNumber,
            hasManagementRole: this.props.associate.otherData.hasManagementRole,
            managementRoles: associate.otherData.managementRoles,
            hasPublicAdminRole: this.props.associate.otherData.hasPublicAdminRole,
            publicAdminRoles: associate.otherData.publicAdminRoles,
            hasEthicsCommitteeRole: this.props.associate.otherData.hasEthicsCommitteeRole,
            ethicsCommitteeRoles: associate.otherData.ethicsCommitteeRoles,
            hasQualityCommitteRole: this.props.associate.otherData.hasQualityCommitteRole,
            qualityCommitteRoles: associate.otherData.qualityCommitteRoles,
            hasOrganizationalRole: this.props.associate.otherData.hasOrganizationalRole,
            organizationalRoles: associate.otherData.organizationalRoles
        });
    }

    saveChanges() {
        if(this.validateForm()) {

            let associate = this.props.associate;

            associate.otherData = {
                businessOwner: this.state.businessOwner,
                businessName: this.state.businessName,
                professionalsNumber: this.state.professionalsNumber,
                hasManagementRole: null,
                managementRoles: this.state.managementRoles,
                hasPublicAdminRole: null,
                publicAdminRoles: this.state.publicAdminRoles,
                hasEthicsCommitteeRole: null,
                ethicsCommitteeRoles: this.state.ethicsCommitteeRoles,
                hasQualityCommitteRole: null,
                qualityCommitteRoles: this.state.qualityCommitteRoles,
                hasOrganizationalRole: null,
                organizationalRoles: this.state.organizationalRoles
            };

            if(this.state.addManagementMode === true) { 
                associate.otherData.managementRoles.push({
                    role: this.state.cursorManagementRole,
                    professionalsNumber: this.state.cursorManagementProfessionalsNumber,
                    workplace: this.state.cursorManagementWorkplace,
                    beginDate: this.state.cursorManagementBeginDate,
                    endDate: this.state.cursorManagementEndDate
                });
            }

            if(this.state.addPublicAdminMode === true) {
                associate.otherData.publicAdminRoles.push({
                    role: this.state.cursorPublicAdminRole,
                    workplace: this.state.cursorPublicAdminWorkplace,
                    beginDate: this.state.cursorPublicAdminBeginDate,
                    endDate: this.state.cursorPublicAdminEndDate
                });
            }

            if(this.state.addEthicsMode === true) {
                associate.otherData.ethicsCommitteeRoles.push({
                    role: this.state.cursorEthicRole,
                    workplace: this.state.cursorEthicWorkplace,
                    beginDate: this.state.cursorEthicBeginDate,
                    endDate: this.state.cursorEthicEndDate
                });
            }

            if(this.state.addQualityMode === true) {
                associate.otherData.qualityCommitteRoles.push({
                    role: this.state.cursorQualityRole,
                    workplace: this.state.cursorQualityWorkplace,
                    beginDate: this.state.cursorQualityBeginDate,
                    endDate: this.state.cursorQualityEndDate
                });
            }
    
            if(this.state.addOrganizationalMode === true) {
                associate.otherData.organizationalRoles.push({
                    workplace: this.state.cursorOrganizationalWorkplace,
                    beginDate: this.state.cursorOrganizationalBeginDate,
                    endDate: this.state.cursorOrganizationalEndDate
                });
            }

            ProfileService.updateAssociateData(formatAssociateDataToService(associate), this.props.t('general.update-record'), OTHER_ROLES)
            .then((response) => {
                this.setState({
                    readOnlyMode: true
                });
    
                this.clearComponentVariables();
                this.props.setEditMode(false);
                this.props.getAssociateData(this.props.registrationRef);

                setTimeout(() => {
                    this.setState({
                        associate: this.props.associate
                    });
                }, 1500);
            })
            .catch(error => {
                this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
            });
        }
    }

    validateForm() {
        let validationResult = true;

        let validBusinessName = true;
        let validProfessionalsNumber = true;

        if(this.state.businessOwner.code === YES_OPTION.code) {
            validBusinessName = (this.state.businessName !== "");
            validProfessionalsNumber = (this.state.professionalsNumber !== "");
        }

        // Existing management roles validation
        let validManagementRolesRole = [true, true, true];
        let validManagementRolesWorkplace = [true, true, true];
        let validManagementRolesBeginDate = [true, true, true];
        let validManagementRolesProfessionalsNumber = [true, true, true];

        for (let i = 0; i < validManagementRolesRole.length; i++) {
            if(i+1 > this.state.managementRoles.length) {
                validManagementRolesRole[i] = true;
                validManagementRolesWorkplace[i] = true;
                validManagementRolesBeginDate[i] = true;
                validManagementRolesProfessionalsNumber[i] = true;
            }
            else {
                validManagementRolesRole[i] = (this.state.managementRoles[i].role !== "");
                validManagementRolesWorkplace[i] = (this.state.managementRoles[i].workplace !== "");
                validManagementRolesBeginDate[i] = (this.state.managementRoles[i].beginDate !== null);
                validManagementRolesProfessionalsNumber[i] = (this.state.managementRoles[i].professionalsNumber !== "");
            }
        }

        // Existing public admin roles validation
        let validPublicAdminRolesRole = [true, true, true];
        let validPublicAdminRolesWorkplace = [true, true, true];
        let validPublicAdminRolesBeginDate = [true, true, true];

        for (let i = 0; i < validPublicAdminRolesRole.length; i++) {
            if(i+1 > this.state.publicAdminRoles.length) {
                validPublicAdminRolesRole[i] = true;
                validPublicAdminRolesWorkplace[i] = true;
                validPublicAdminRolesBeginDate[i] = true;
            }
            else {
                validPublicAdminRolesRole[i] = (this.state.publicAdminRoles[i].role !== "");
                validPublicAdminRolesWorkplace[i] = (this.state.publicAdminRoles[i].workplace !== "");
                validPublicAdminRolesBeginDate[i] = (this.state.publicAdminRoles[i].beginDate !== null);
            }
        }

        // Existing ethic roles validation
        let validEthicRolesRole = [true, true, true];
        let validEthicRolesWorkplace = [true, true, true];
        let validEthicRolesBeginDate = [true, true, true];

        for (let i = 0; i < validEthicRolesRole.length; i++) {
            if(i+1 > this.state.ethicsCommitteeRoles.length) {
                validEthicRolesRole[i] = true;
                validEthicRolesWorkplace[i] = true;
                validEthicRolesBeginDate[i] = true;
            }
            else {
                validEthicRolesRole[i] = (this.state.ethicsCommitteeRoles[i].role !== "");
                validEthicRolesWorkplace[i] = (this.state.ethicsCommitteeRoles[i].workplace !== "");
                validEthicRolesBeginDate[i] = (this.state.ethicsCommitteeRoles[i].beginDate !== null);
            }
        }

        // Existing quality roles validation
        let validQualityRolesRole = [true, true, true];
        let validQualityRolesWorkplace = [true, true, true];
        let validQualityRolesBeginDate = [true, true, true];

        for (let i = 0; i < validQualityRolesRole.length; i++) {
            if(i+1 > this.state.qualityCommitteRoles.length) {
                validQualityRolesRole[i] = true;
                validQualityRolesWorkplace[i] = true;
                validQualityRolesBeginDate[i] = true;
            }
            else {
                validQualityRolesRole[i] = (this.state.qualityCommitteRoles[i].role !== "");
                validQualityRolesWorkplace[i] = (this.state.qualityCommitteRoles[i].workplace !== "");
                validQualityRolesBeginDate[i] = (this.state.qualityCommitteRoles[i].beginDate !== null);
            }
        }

        // Existing organizational roles validation
        let validOrganizationalRolesWorkplace = [true, true, true];
        let validOrganizationalRolesBeginDate = [true, true, true];

        for (let i = 0; i < validQualityRolesRole.length; i++) {
            if(i+1 > this.state.organizationalRoles.length) {
                validOrganizationalRolesWorkplace[i] = true;
                validOrganizationalRolesBeginDate[i] = true;
            }
            else {
                validOrganizationalRolesWorkplace[i] = (this.state.organizationalRoles[i].workplace !== "");
                validOrganizationalRolesBeginDate[i] = (this.state.organizationalRoles[i].beginDate !== null);
            }
        }

        this.setState({
            validBusinessName: validBusinessName,
            validProfessionalsNumber: validProfessionalsNumber,
            validManagementRole: (this.state.addManagementMode === false || this.state.cursorManagementRole !== ""),
            validManagementProfessionalsNumber: (this.state.addManagementMode === false || this.state.cursorManagementProfessionalsNumber !== ""),
            validManagementWorkplace: (this.state.addManagementMode === false || this.state.cursorManagementWorkplace !== ""),
            validManagementBeginDate: (this.state.addManagementMode === false || this.state.cursorManagementBeginDate !== null),
            validPublicAdminRole: (this.state.addPublicAdminMode === false || this.state.cursorPublicAdminRole !== ""),
            validPublicAdminWorkplace: (this.state.addPublicAdminMode === false || this.state.cursorPublicAdminWorkplace !== ""),
            validPublicAdminBeginDate: (this.state.addPublicAdminMode === false || this.state.cursorPublicAdminBeginDate !== null),
            validEthicRole: (this.state.addEthicsMode === false || this.state.cursorEthicRole !== ""),
            validEthicWorkplace: (this.state.addEthicsMode === false || this.state.cursorEthicWorkplace !== ""),
            validEthicBeginDate: (this.state.addEthicsMode === false || this.state.cursorEthicBeginDate !== null),
            validQualityRole: (this.state.addQualityMode === false || this.state.cursorQualityRole !== ""),
            validQualityWorkplace: (this.state.addQualityMode === false || this.state.cursorQualityWorkplace !== ""),
            validQualityBeginDate: (this.state.addQualityMode === false || this.state.cursorQualityBeginDate !== null),
            validOrganizationalWorkplace: (this.state.addOrganizationalMode === false || this.state.cursorOrganizationalWorkplace !== ""),
            validOrganizationalBeginDate : (this.state.addOrganizationalMode === false || this.state.cursorOrganizationalBeginDate !== null),
            validManagementRolesRole: validManagementRolesRole,
            validManagementRolesWorkplace: validManagementRolesWorkplace,
            validManagementRolesBeginDate: validManagementRolesBeginDate,
            validManagementRolesProfessionalsNumber: validManagementRolesProfessionalsNumber,
            validPublicAdminRolesRole: validPublicAdminRolesRole,
            validPublicAdminRolesWorkplace: validPublicAdminRolesWorkplace,
            validPublicAdminRolesBeginDate: validPublicAdminRolesBeginDate,
            validEthicRolesRole: validEthicRolesRole,
            validEthicRolesWorkplace: validEthicRolesWorkplace,
            validEthicRolesBeginDate: validEthicRolesBeginDate,
            validQualityRolesRole: validQualityRolesRole,
            validQualityRolesWorkplace: validQualityRolesWorkplace,
            validQualityRolesBeginDate: validQualityRolesBeginDate,
            validOrganizationalRolesWorkplace: validOrganizationalRolesWorkplace,
            validOrganizationalRolesBeginDate: validOrganizationalRolesBeginDate
        });

        validationResult = (validBusinessName &&
                            validProfessionalsNumber &&
                            (this.state.addManagementMode === false || this.state.cursorManagementRole !== "") &&
                            (this.state.addManagementMode === false || this.state.cursorManagementProfessionalsNumber !== "") &&
                            (this.state.addManagementMode === false || this.state.cursorManagementWorkplace !== "") &&
                            (this.state.addManagementMode === false || this.state.cursorManagementBeginDate !== null) &&
                            (this.state.addPublicAdminMode === false || this.state.cursorPublicAdminRole !== "") &&
                            (this.state.addPublicAdminMode === false || this.state.cursorPublicAdminWorkplace !== "") &&
                            (this.state.addPublicAdminMode === false || this.state.cursorPublicAdminBeginDate !== null) &&
                            (this.state.addEthicsMode === false || this.state.cursorEthicRole !== "") &&
                            (this.state.addEthicsMode === false || this.state.cursorEthicWorkplace !== "") &&
                            (this.state.addEthicsMode === false || this.state.cursorEthicBeginDate !== null) &&
                            (this.state.addQualityMode === false || this.state.cursorQualityRole !== "") &&
                            (this.state.addQualityMode === false || this.state.cursorQualityWorkplace !== "") &&
                            (this.state.addQualityMode === false || this.state.cursorQualityBeginDate !== null) &&
                            (this.state.addOrganizationalMode === false || this.state.cursorOrganizationalWorkplace !== "") &&
                            (this.state.addOrganizationalMode === false || this.state.cursorOrganizationalBeginDate !== null) &&
                            this.ruleCollectionIsValid(validManagementRolesRole) &&
                            this.ruleCollectionIsValid(validManagementRolesWorkplace) &&
                            this.ruleCollectionIsValid(validManagementRolesBeginDate) &&
                            this.ruleCollectionIsValid(validManagementRolesProfessionalsNumber) &&
                            this.ruleCollectionIsValid(validPublicAdminRolesRole) &&
                            this.ruleCollectionIsValid(validPublicAdminRolesWorkplace) &&
                            this.ruleCollectionIsValid(validPublicAdminRolesBeginDate) &&
                            this.ruleCollectionIsValid(validEthicRolesRole) &&
                            this.ruleCollectionIsValid(validEthicRolesWorkplace) &&
                            this.ruleCollectionIsValid(validEthicRolesBeginDate) &&
                            this.ruleCollectionIsValid(validQualityRolesRole) &&
                            this.ruleCollectionIsValid(validQualityRolesWorkplace) &&
                            this.ruleCollectionIsValid(validQualityRolesBeginDate) &&
                            this.ruleCollectionIsValid(validOrganizationalRolesWorkplace) &&
                            this.ruleCollectionIsValid(validOrganizationalRolesBeginDate));

        return validationResult;
    }

    ruleCollectionIsValid(collection) {
        for (let i = 0; i < collection.length; i++) {
            if(collection[i] === false) return false;
        }

        return true;
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: value
        });

        if(column === "businessOwner") {
            this.setState({
                businessName: "",
                professionalsNumber: ""
            });
        }
    }

    setEthicsMode() {
        this.setState({
            addEthicsMode: true
        });
    }

    setQualityMode() {
        this.setState({
            addQualityMode: true
        });
    }

    setManagementMode() {
        this.setState({
            addManagementMode: true
        });
    }

    setOrganizationalMode() {
        this.setState({
            addOrganizationalMode: true
        });
    }

    setPublicAdminMode() {
        this.setState({
            addPublicAdminMode: true
        });
    }

    clearComponentVariables() {
        this.setState({
            readOnlyMode: true,
            addEthicsMode: false,
            addManagementMode: false,
            addPublicAdminMode: false,
            addQualityMode: false,
            addOrganizationalMode: false,
            cursorManagementRole: "",
            cursorManagementWorkplace: "",
            cursorManagementProfessionalsNumber: "",
            cursorManagementBeginDate: null,
            cursorManagementEndDate: null,
            cursorPublicAdminRole: "",
            cursorPublicAdminWorkplace: "",
            cursorPublicAdminBeginDate: null,
            cursorPublicAdminEndDate: null,
            cursorEthicRole: "",
            cursorEthicWorkplace: "",
            cursorEthicBeginDate: null,
            cursorEthicEndDate: null,
            cursorQualityRole: "",
            cursorQualityWorkplace: "",
            cursorQualityBeginDate: null,
            cursorQualityEndDate: null,
            cursorOrganizationalWorkplace: "",
            cursorOrganizationalBeginDate: null,
            cursorOrganizationalEndDate: null,
            validBusinessName: true,
            validProfessionalsNumber: true,
            validManagementRole: true,
            validManagementProfessionalsNumber: true,
            validManagementWorkplace: true,
            validManagementBeginDate: true,
            validPublicAdminRole: true,
            validPublicAdminWorkplace: true,
            validPublicAdminBeginDate: true,
            validEthicRole: true,
            validEthicBeginDate: true,
            validEthicWorkplace: true,
            validQualityBeginDate: true,
            validQualityRole: true,
            validQualityWorkplace: true,
            validOrganizationalBeginDate: true,
            validOrganizationalWorkplace: true,
            // Management roles validation 
            validManagementRolesRole: [true, true, true],
            validManagementRolesWorkplace: [true, true, true],
            validManagementRolesBeginDate: [true, true, true],
            validManagementRolesProfessionalsNumber: [true, true, true],
            // Public admin roles validation 
            validPublicAdminRolesRole: [true, true, true],
            validPublicAdminRolesWorkplace: [true, true, true],
            validPublicAdminRolesBeginDate: [true, true, true],
            // Ethic roles validation 
            validEthicRolesRole: [true, true, true],
            validEthicRolesWorkplace: [true, true, true],
            validEthicRolesBeginDate: [true, true, true],
            // Quality roles validation 
            validQualityRolesRole: [true, true, true],
            validQualityRolesWorkplace: [true, true, true],
            validQualityRolesBeginDate: [true, true, true],
            // Organizational roles validation 
            validOrganizationalRolesWorkplace: [true, true, true, true, true, true, true, true, true, true],
            validOrganizationalRolesBeginDate: [true, true, true, true, true, true, true, true, true, true]
        });
    }

    updateManagementRolesData(order, field, value) {
        let managementRoles = this.state.managementRoles;

        for (let i = 0; i < managementRoles.length; i++) {
            if(managementRoles[i].order === order) {
                managementRoles[i][field] = value;
            }
        }

        this.setState({
            managementRoles: managementRoles
        });
    }

    updatePublicAdminRolesData(order, field, value) {
        let publicAdminRoles = this.state.publicAdminRoles;

        for (let i = 0; i < publicAdminRoles.length; i++) {
            if(publicAdminRoles[i].order === order) {
                publicAdminRoles[i][field] = value;
            }
        }

        this.setState({
            publicAdminRoles: publicAdminRoles
        });
    }

    updateEthicRolesData(order, field, value) {
        let ethicsCommitteeRoles = this.state.ethicsCommitteeRoles;

        for (let i = 0; i < ethicsCommitteeRoles.length; i++) {
            if(ethicsCommitteeRoles[i].order === order) {
                ethicsCommitteeRoles[i][field] = value;
            }
        }

        this.setState({
            ethicsCommitteeRoles: ethicsCommitteeRoles
        });
    }

    updateQualityRolesData(order, field, value) {
        let qualityCommitteRoles = this.state.qualityCommitteRoles;

        for (let i = 0; i < qualityCommitteRoles.length; i++) {
            if(qualityCommitteRoles[i].order === order) {
                qualityCommitteRoles[i][field] = value;
            }
        }

        this.setState({
            qualityCommitteRoles: qualityCommitteRoles
        });
    }

    updateOrganizationalRolesData(order, field, value) {
        let organizationalRoles = this.state.organizationalRoles;

        for (let i = 0; i < organizationalRoles.length; i++) {
            if(organizationalRoles[i].order === order) {
                organizationalRoles[i][field] = value;
            }
        }

        this.setState({
            organizationalRoles: organizationalRoles
        });
    }

    formatOtherDataFormValues(sourceAssociate, language = "pt") {
        let associate = {
            otherData: { 
                managementRoles: [],
                publicAdminRoles: [],
                qualityCommitteRoles: [],
                ethicsCommitteeRoles: [],
                organizationalRoles: []
            }
        };

        if(typeof sourceAssociate.otherData.businessOwner !== 'object' && sourceAssociate.otherData.businessOwner !== null) {
            associate.otherData.businessOwner = formatYesNoDropdownLists(sourceAssociate.otherData.businessOwner, language);
        }
        else if (typeof sourceAssociate.otherData.businessOwner === 'object' && sourceAssociate.otherData.businessOwner !== null) {
            associate.otherData.businessOwner = formatYesNoDropdownLists(sourceAssociate.otherData.businessOwner.code === YES_OPTION.code, language);
        }
    
        associate.otherData.hasManagementRole = formatYesNoDropdownLists(sourceAssociate.otherData.managementRoles.length > 0, language);
    
        for (let i = 0; i < sourceAssociate.otherData.managementRoles.length; i++) {
            associate.otherData.managementRoles.push({
                order: sourceAssociate.otherData.managementRoles[i].order,
                professionalsNumber: sourceAssociate.otherData.managementRoles[i].professionalsNumber,
                role: sourceAssociate.otherData.managementRoles[i].role,
                workplace: sourceAssociate.otherData.managementRoles[i].workplace,
                beginDate: sourceAssociate.otherData.managementRoles[i].beginDate !== null ? new Date(sourceAssociate.otherData.managementRoles[i].beginDate) : null,
                endDate: sourceAssociate.otherData.managementRoles[i].endDate !== null ? new Date(sourceAssociate.otherData.managementRoles[i].endDate) : null
            });
        }
    
        associate.otherData.hasPublicAdminRole = formatYesNoDropdownLists(sourceAssociate.otherData.publicAdminRoles.length > 0, language);
    
        for (let i = 0; i < sourceAssociate.otherData.publicAdminRoles.length; i++) {
            associate.otherData.publicAdminRoles.push({
                order: sourceAssociate.otherData.publicAdminRoles[i].order,
                role: sourceAssociate.otherData.publicAdminRoles[i].role,
                workplace: sourceAssociate.otherData.publicAdminRoles[i].workplace,
                beginDate: sourceAssociate.otherData.publicAdminRoles[i].beginDate !== null ? new Date(sourceAssociate.otherData.publicAdminRoles[i].beginDate) : null,
                endDate: sourceAssociate.otherData.publicAdminRoles[i].endDate !== null ? new Date(sourceAssociate.otherData.publicAdminRoles[i].endDate) : null
            });
        }
    
        associate.otherData.hasQualityCommitteRole = formatYesNoDropdownLists(sourceAssociate.otherData.qualityCommitteRoles.length > 0, language);
    
        for (let i = 0; i < sourceAssociate.otherData.qualityCommitteRoles.length; i++) {
            associate.otherData.qualityCommitteRoles.push({
                order: sourceAssociate.otherData.qualityCommitteRoles[i].order,
                role: sourceAssociate.otherData.qualityCommitteRoles[i].role,
                workplace: sourceAssociate.otherData.qualityCommitteRoles[i].workplace,
                beginDate: sourceAssociate.otherData.qualityCommitteRoles[i].beginDate !== null ? new Date(sourceAssociate.otherData.qualityCommitteRoles[i].beginDate) : null,
                endDate: sourceAssociate.otherData.qualityCommitteRoles[i].endDate !== null ? new Date(sourceAssociate.otherData.qualityCommitteRoles[i].endDate) : null
            });
        }
    
        associate.otherData.hasEthicsCommitteeRole = formatYesNoDropdownLists(sourceAssociate.otherData.ethicsCommitteeRoles.length > 0, language);
    
        for (let i = 0; i < sourceAssociate.otherData.ethicsCommitteeRoles.length; i++) {
            associate.otherData.ethicsCommitteeRoles.push({
                order: sourceAssociate.otherData.ethicsCommitteeRoles[i].order,
                role: sourceAssociate.otherData.ethicsCommitteeRoles[i].role,
                workplace: sourceAssociate.otherData.ethicsCommitteeRoles[i].workplace,
                beginDate: sourceAssociate.otherData.ethicsCommitteeRoles[i].beginDate !== null ? new Date(sourceAssociate.otherData.ethicsCommitteeRoles[i].beginDate) : null,
                endDate: sourceAssociate.otherData.ethicsCommitteeRoles[i].endDate !== null ? new Date(sourceAssociate.otherData.ethicsCommitteeRoles[i].endDate) : null
            });
        }
    
        associate.otherData.hasOrganizationalRole = formatYesNoDropdownLists(sourceAssociate.otherData.organizationalRoles.length > 0, language);
    
        for (let i = 0; i < sourceAssociate.otherData.organizationalRoles.length; i++) {
            associate.otherData.organizationalRoles.push({
                order: sourceAssociate.otherData.organizationalRoles[i].order,
                workplace: sourceAssociate.otherData.organizationalRoles[i].workplace,
                beginDate: sourceAssociate.otherData.organizationalRoles[i].beginDate !== null ? new Date(sourceAssociate.otherData.organizationalRoles[i].beginDate) : null,
                endDate: sourceAssociate.otherData.organizationalRoles[i].endDate !== null ? new Date(sourceAssociate.otherData.organizationalRoles[i].endDate) : null
            });
        }
    
        return associate;
    }

  render() {

    return (
        this.props.associate !== null && this.props.associate.otherData !== null && this.state.businessOwner !== null ? 
            <div className='grid mgb-80'>
                <Tooltip target=".other-data-help-icon" />
                <div className='col-12'>
                    <div className="card p-fluid mgt-20">
                        <div className='grid'>
                            <div className='col-12 t-align-right'>
                                {
                                    this.state.readOnlyMode === true ? 
                                        <Button icon="pi pi-pencil" className="p-button-rounded mr-2 mb-2" disabled={!this.props.registrationApproved} onClick={() => this.activateEditMode()} />
                                        :   
                                        <>
                                            <Button icon="pi pi-check" className="p-button-rounded p-button-success mr-2 mb-2" onClick={() => this.saveChanges()} />
                                            <Button icon="pi pi-ban" className="p-button-rounded p-button-danger mr-2 mb-2" onClick={() => this.cancelEditMode()} />
                                        </>
                                }
                            </div>  
                            <div className='col-12 t-align-left'>
                                <span>
                                    <b className='mgr-5'>{this.props.t("profile.areas.other.management-competency")}</b>
                                </span>
                            </div>
                            <div className='col-12 t-align-left'>
                                <label htmlFor="businessOwner">{this.props.t("profile.areas.other.business-owner")} <span className="invalid-message">*</span></label>
                                <Dropdown id="businessOwner" disabled={this.state.readOnlyMode} value={this.state.businessOwner} options={getYesNoDropdownList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("businessOwner", evt.value)}></Dropdown>
                            </div>
                            {
                                this.state.businessOwner.code === YES_OPTION.code ? 
                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                        <label htmlFor="businessName">{this.props.t("profile.areas.other.business-name")} <span className="invalid-message">*</span></label>
                                        <InputText id="businessName" disabled={this.state.readOnlyMode} value={this.state.businessName} type="text" onChange={(evt) => this.updateFormComponent("businessName", evt.target.value)}/>
                                        { this.state.validBusinessName ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                    </div>
                                    : 
                                    null
                            }
                            {
                                this.state.businessOwner.code === YES_OPTION.code ? 
                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                        <label htmlFor="employeeNum">{this.props.t("profile.areas.other.employee-number")} <span className="invalid-message">*</span></label>
                                        <InputText id="employeeNum" disabled={this.state.readOnlyMode} value={this.state.professionalsNumber} type="number" onChange={(evt) => this.updateFormComponent("professionalsNumber", evt.target.value)}/>
                                        { this.state.validProfessionalsNumber ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                    </div>
                                    : 
                                    null
                            }
                            <div className='col-12 t-align-left'>
                                <label htmlFor="boss">{this.props.t("profile.areas.other.management-role")} <span className="invalid-message">*</span></label>
                                <Dropdown id="boss" disabled={true} value={this.state.hasManagementRole} options={getYesNoDropdownList(getLanguage())} optionLabel="name"></Dropdown>
                            </div>
                            {
                                this.state.managementRoles.map((role) => { 
                                    return <div key={role.order} className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                                <div className='grid'>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="managementRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                        <InputText id="managementRole" disabled={this.state.readOnlyMode} value={role.role} type="text" onChange={(evt) => this.updateManagementRolesData(role.order, "role", evt.target.value)} />
                                                        { this.state.validManagementRolesRole[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="managementInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                        <InputText id="managementInstitution" disabled={this.state.readOnlyMode} value={role.workplace} type="text" onChange={(evt) => this.updateManagementRolesData(role.order, "workplace", evt.target.value)} />
                                                        { this.state.validManagementRolesWorkplace[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="managementBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                        <Calendar disabled={this.state.readOnlyMode} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.beginDate} showIcon showButtonBar onChange={(evt) => this.updateManagementRolesData(role.order, "beginDate", evt.target.value)} />
                                                        { this.state.validManagementRolesBeginDate[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="managementEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                        <Calendar disabled={this.state.readOnlyMode} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.endDate} showIcon showButtonBar onChange={(evt) => this.updateManagementRolesData(role.order, "endDate", evt.target.value)} />
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="managementEmployeeNum">{this.props.t("profile.areas.other.physio-num")} <span className="invalid-message">*</span></label>
                                                        <InputText id="managementEmployeeNum" disabled={this.state.readOnlyMode} value={role.professionalsNumber} type="number" onChange={(evt) => this.updateManagementRolesData(role.order, "professionalsNumber", evt.target.value)} />
                                                        { this.state.validManagementRolesProfessionalsNumber[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                </div>
                                            </div>
                                })
                            }
                            {
                                !this.state.readOnlyMode && !this.state.addManagementMode && this.state.managementRoles.length < 3 ?
                                    <div className='col-12 t-align-center'>
                                        <Button icon="pi pi-plus" className="mr-2 mb-2" style={{width: "200px"}} onClick={() => this.setManagementMode()}>
                                            <span className='mgl-10'>{this.props.t("profile.areas.other.add-role")}</span>
                                        </Button>                              
                                    </div>
                                    : null
                            }
                            {
                                !this.state.readOnlyMode && this.state.addManagementMode ?
                                    <div className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                        <div className='grid'>
                                            <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                <label htmlFor="editManagementRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                <InputText id="editManagementRole" value={this.state.cursorManagementRole} type="text" onChange={(evt) => this.setState({ cursorManagementRole: evt.target.value })} />
                                                { this.state.validManagementRole ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                <label htmlFor="editManagementInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                <InputText id="editManagementInstitution" value={this.state.cursorManagementWorkplace} type="text" onChange={(evt) => this.setState({ cursorManagementWorkplace: evt.target.value })} />
                                                { this.state.validManagementWorkplace ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="editManagementBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorManagementBeginDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorManagementBeginDate: evt.value })} />
                                                { this.state.validManagementBeginDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="editManagementEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorManagementEndDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorManagementEndDate: evt.value })} />
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="editManagementEmployeeNum">{this.props.t("profile.areas.other.physio-num")} <span className="invalid-message">*</span></label>
                                                <InputText id="editManagementEmployeeNum" value={this.state.cursorManagementProfessionalsNumber} type="number" onChange={(evt) => this.setState({ cursorManagementProfessionalsNumber: evt.target.value })} />
                                                { this.state.validManagementProfessionalsNumber ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                        </div>
                                    </div> : null
                            }
                            <div className='col-12 t-align-left'>
                                <label htmlFor="publicAdmin">{this.props.t("profile.areas.other.public-admin-role")} 
                                    <span className="invalid-message mgr-5">*</span>
                                    <i className="other-data-help-icon pi pi-question-circle p-text-secondary" data-pr-tooltip={this.props.t("profile.areas.other.help-messages.public-admin")} data-pr-position="right" data-pr-at="right+5 center" data-pr-my="left center-2" style={{ color:"#0073aa", fontSize:"16px", fontWeight:"bold", cursor: 'pointer' }}></i>
                                </label>
                                <Dropdown id="publicAdmin" disabled={true} value={this.state.hasPublicAdminRole} options={getYesNoDropdownList(getLanguage())} optionLabel="name"></Dropdown>
                            </div>
                            {
                                this.state.publicAdminRoles.map((role) => { 
                                    return <div key={role.order} className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                                <div className='grid'>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="publicAdminRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                        <InputText disabled={this.state.readOnlyMode} id="publicAdminRole" value={role.role} type="text" onChange={(evt) => this.updatePublicAdminRolesData(role.order, "role", evt.target.value)}/>
                                                        { this.state.validPublicAdminRolesRole[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="publicAdminInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                        <InputText disabled={this.state.readOnlyMode} id="publicAdminInstitution" value={role.workplace} type="text" onChange={(evt) => this.updatePublicAdminRolesData(role.order, "workplace", evt.target.value)} />
                                                        { this.state.validPublicAdminRolesWorkplace[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="publicAdminBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                        <Calendar disabled={this.state.readOnlyMode} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.beginDate} showIcon showButtonBar onChange={(evt) => this.updatePublicAdminRolesData(role.order, "beginDate", evt.target.value)} />
                                                        { this.state.validPublicAdminRolesBeginDate[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="publicAdminEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                        <Calendar disabled={this.state.readOnlyMode} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.endDate} showIcon showButtonBar onChange={(evt) => this.updatePublicAdminRolesData(role.order, "endDate", evt.target.value)} />
                                                    </div>
                                                </div>
                                            </div>
                                })
                            }
                            {
                                !this.state.readOnlyMode && !this.state.addPublicAdminMode && this.state.publicAdminRoles.length < 3 ?
                                    <div className='col-12 t-align-center'>
                                        <Button icon="pi pi-plus" className="mr-2 mb-2" style={{width: "200px"}} onClick={() => this.setPublicAdminMode()}>
                                            <span className='mgl-10'>{this.props.t("profile.areas.other.add-role")}</span>
                                        </Button>                              
                                    </div>
                                    : null
                            }
                            {
                                !this.state.readOnlyMode && this.state.addPublicAdminMode ?
                                    <div className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                        <div className='grid'>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editPublicAdminRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                <InputText id="editPublicAdminRole" value={this.state.cursorPublicAdminRole} type="text" onChange={(evt) => this.setState({ cursorPublicAdminRole: evt.target.value })} />
                                                { this.state.validPublicAdminRole ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editPublicAdminInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                <InputText id="editPublicAdminInstitution" value={this.state.cursorPublicAdminWorkplace} type="text" onChange={(evt) => this.setState({ cursorPublicAdminWorkplace: evt.target.value })} />
                                                { this.state.validPublicAdminWorkplace ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editPublicAdminBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorPublicAdminBeginDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorPublicAdminBeginDate: evt.value })} />
                                                { this.state.validPublicAdminBeginDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editPublicAdminEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorPublicAdminEndDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorPublicAdminEndDate: evt.value })} />
                                            </div>
                                        </div>
                                    </div> : null
                            }
                            <div className='col-12 t-align-left'>
                                <label htmlFor="ethic">{this.props.t("profile.areas.other.ethic-role")} <span className="invalid-message">*</span></label>
                                <Dropdown id="ethic" disabled={true} value={this.state.hasEthicsCommitteeRole} options={getYesNoDropdownList(getLanguage())} optionLabel="name"></Dropdown>
                            </div>
                            {
                                this.state.ethicsCommitteeRoles.map((role) => { 
                                    return <div key={role.order} className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                                <div className='grid'>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="ethicRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                        <InputText id="ethicRole" disabled={this.state.readOnlyMode} value={role.role} type="text" onChange={(evt) => this.updateEthicRolesData(role.order, "role", evt.target.value)} />
                                                        { this.state.validEthicRolesRole[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="ethicInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                        <InputText id="ethicInstitution" disabled={this.state.readOnlyMode} value={role.workplace} type="text" onChange={(evt) => this.updateEthicRolesData(role.order, "workplace", evt.target.value)} />
                                                        { this.state.validEthicRolesWorkplace[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="ethicBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                        <Calendar disabled={this.state.readOnlyMode} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.beginDate} showIcon showButtonBar onChange={(evt) => this.updateEthicRolesData(role.order, "beginDate", evt.target.value)} />
                                                        { this.state.validEthicRolesBeginDate[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="ethicEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                        <Calendar disabled={this.state.readOnlyMode} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.endDate} showIcon showButtonBar onChange={(evt) => this.updateEthicRolesData(role.order, "endDate", evt.target.value)} />
                                                    </div>
                                                </div>
                                            </div>
                                })
                            }
                            {
                                !this.state.readOnlyMode && !this.state.addEthicsMode && this.state.ethicsCommitteeRoles.length < 3 ?
                                    <div className='col-12 t-align-center'>
                                        <Button icon="pi pi-plus" className="mr-2 mb-2" style={{width: "200px"}} onClick={() => this.setEthicsMode()}>
                                            <span className='mgl-10'>{this.props.t("profile.areas.other.add-role")}</span>
                                        </Button>                              
                                    </div>
                                    : null
                            }
                            {
                                !this.state.readOnlyMode && this.state.addEthicsMode ?
                                    <div className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                        <div className='grid'>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editEthicRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                <InputText id="editEthicRole" value={this.state.cursorEthicRole} type="text" onChange={(evt) => this.setState({ cursorEthicRole: evt.target.value })} />
                                                { this.state.validEthicRole ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editEthicInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                <InputText id="editEthicInstitution" value={this.state.cursorEthicWorkplace} type="text" onChange={(evt) => this.setState({ cursorEthicWorkplace: evt.target.value })} />
                                                { this.state.validEthicWorkplace ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editEthicBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorEthicBeginDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorEthicBeginDate: evt.value })} />
                                                { this.state.validEthicBeginDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editEthicEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorEthicEndDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorEthicEndDate: evt.value })} />
                                            </div>
                                        </div>
                                    </div> : null
                            }
                            <div className='col-12 t-align-left'>
                                <label htmlFor="quality">{this.props.t("profile.areas.other.quality-role")} <span className="invalid-message">*</span></label>
                                <Dropdown id="quality" disabled={true} value={this.state.hasQualityCommitteRole} options={getYesNoDropdownList(getLanguage())} optionLabel="name"></Dropdown>
                            </div>
                            {
                                this.state.qualityCommitteRoles.map((role) => { 
                                    return <div key={role.order} className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                                <div className='grid'>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="qualityRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                        <InputText id="qualityRole" disabled={this.state.readOnlyMode} value={role.role} type="text" onChange={(evt) => this.updateQualityRolesData(role.order, "role", evt.target.value)} />
                                                        { this.state.validQualityRolesRole[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="qualityInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                        <InputText id="qualityInstitution" disabled={this.state.readOnlyMode} value={role.workplace} type="text" onChange={(evt) => this.updateQualityRolesData(role.order, "workplace", evt.target.value)} />
                                                        { this.state.validQualityRolesWorkplace[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="qualityBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                        <Calendar disabled={this.state.readOnlyMode} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.beginDate} showIcon showButtonBar onChange={(evt) => this.updateQualityRolesData(role.order, "beginDate", evt.target.value)} />
                                                        { this.state.validQualityRolesBeginDate[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                        <label htmlFor="qualityEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                        <Calendar disabled={this.state.readOnlyMode} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.endDate} showIcon showButtonBar onChange={(evt) => this.updateQualityRolesData(role.order, "endDate", evt.target.value)} />
                                                    </div>
                                                </div>
                                            </div>
                                }) 
                            }
                            {
                                !this.state.readOnlyMode && !this.state.addQualityMode && this.state.qualityCommitteRoles.length < 3 ?
                                    <div className='col-12 t-align-center'>
                                        <Button icon="pi pi-plus" className="mr-2 mb-2" style={{width: "200px"}} onClick={() => this.setQualityMode()}>
                                            <span className='mgl-10'>{this.props.t("profile.areas.other.add-role")}</span>
                                        </Button>                              
                                    </div>
                                    : null
                            }
                            {
                                !this.state.readOnlyMode && this.state.addQualityMode ?
                                    <div className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                        <div className='grid'>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editQualityRole">{this.props.t("profile.areas.other.role")} <span className="invalid-message">*</span></label>
                                                <InputText id="editQualityRole" value={this.state.cursorQualityRole} type="text" onChange={(evt) => this.setState({ cursorQualityRole: evt.target.value })} />
                                                { this.state.validQualityRole ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editQualityInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                <InputText id="editQualityInstitution" value={this.state.cursorQualityWorkplace} type="text" onChange={(evt) => this.setState({ cursorQualityWorkplace: evt.target.value })} />
                                                { this.state.validQualityWorkplace ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editQualityBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorQualityBeginDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorQualityBeginDate: evt.value })} />
                                                { this.state.validQualityBeginDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-6 t-align-left'>
                                                <label htmlFor="editQualityEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorQualityEndDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorQualityEndDate: evt.value })} />
                                            </div>
                                        </div>
                                    </div> : null
                            }
                            <div className='col-12 t-align-left'>
                                <span><b>{this.props.t("profile.areas.other.professional-competency")}</b></span>
                            </div>
                            <div className='col-12 t-align-left'>
                                <label htmlFor="volunteer">{this.props.t("profile.areas.other.volunteer-role")} <span className="invalid-message">*</span></label>
                                <Dropdown id="volunteer" disabled={true} value={this.state.hasOrganizationalRole} options={getYesNoDropdownList(getLanguage())} optionLabel="name"></Dropdown>
                            </div>
                            {
                                this.state.organizationalRoles.map((role) => { 
                                    return <div key={role.order} className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                                <div className='grid'>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="volunteerInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                        <InputText id="volunteerInstitution" disabled={this.state.readOnlyMode} value={role.workplace} type="text" onChange={(evt) => this.updateOrganizationalRolesData(role.order, "workplace", evt.target.value)} />
                                                        { this.state.validOrganizationalRolesWorkplace[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="volunteerBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                        <Calendar disabled={this.state.readOnlyMode} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.beginDate} showIcon showButtonBar onChange={(evt) => this.updateOrganizationalRolesData(role.order, "beginDate", evt.target.value)} />
                                                        { this.state.validOrganizationalRolesBeginDate[role.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="volunteerEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                        <Calendar disabled={this.state.readOnlyMode} dateFormat="dd/mm/yy" maxDate={new Date()} value={role.endDate} showIcon showButtonBar onChange={(evt) => this.updateOrganizationalRolesData(role.order, "endDate", evt.target.value)} />
                                                    </div>
                                                </div>
                                            </div>
                                })
                            }
                            {
                                !this.state.readOnlyMode && !this.state.addOrganizationalMode && this.state.organizationalRoles.length < 10 ?
                                    <div className='col-12 t-align-center'>
                                        <Button icon="pi pi-plus" className="mr-2 mb-2" style={{width: "200px"}} onClick={() => this.setOrganizationalMode()}>
                                            <span className='mgl-10'>{this.props.t("profile.areas.other.add-role")}</span>
                                        </Button>                              
                                    </div>
                                    : null
                            }
                            {
                                !this.state.readOnlyMode && this.state.addOrganizationalMode ?
                                    <div className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                        <div className='grid'>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="editOrganizationalInstitution">{this.props.t("profile.areas.other.institution")} <span className="invalid-message">*</span></label>
                                                <InputText id="editOrganizationalInstitution" value={this.state.cursorOrganizationalWorkplace} type="text" onChange={(evt) => this.setState({ cursorOrganizationalWorkplace: evt.target.value })} />
                                                { this.state.validOrganizationalWorkplace ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="editOrganizationalBeginDate">{this.props.t("profile.areas.other.begin-date")} <span className="invalid-message">*</span></label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorOrganizationalBeginDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorOrganizationalBeginDate: evt.value })} />
                                                { this.state.validOrganizationalBeginDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                <label htmlFor="editOrganizationalEndDate">{this.props.t("profile.areas.other.end-date")}</label>
                                                <Calendar dateFormat="dd/mm/yy" maxDate={new Date()} value={this.state.cursorOrganizationalEndDate} showIcon showButtonBar onChange={(evt) => this.setState({ cursorOrganizationalEndDate: evt.value })} />
                                            </div>
                                        </div>
                                    </div> : null
                            }
                        </div>
                    </div>
                </div>
                <Toast position='bottom-left' ref={this._toast} />
            </div>
            : null
    );
  }
}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        registrationRef: state.authentication.registrationRef,
        registrationApproved: state.authentication.registrationApproved,
        language: state.profile.language
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        setEditMode: (editMode) => { dispatch(setEditMode(editMode)) },
        getAssociateData: (registrationRef) => { dispatch(getAssociateData(registrationRef)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(OtherDataComponent));